import axios from "axios";
import { saveAPIPayload,decConfigPayload } from "../../common/commonTypes/Icommon";
import { adalConfig } from "../../common/endpoints";

export const saveFormData = async ({ saveData, decConfig,callBackFn }: {saveData:saveAPIPayload,decConfig:decConfigPayload,callBackFn?:()=>void}) => {
  try {
    const response = await axios.post(
      adalConfig.endpoints.multiappdatasave,
      saveData,
      decConfig
    );
    callBackFn?.();
    return response.data;
  } catch (error: any) {
    throw new Error(error.response.data.message || "Something went wrong");
  }
};
